import type { Invoice } from '@bambi/api-client/schemas';
import { FormError } from '@bambi/component-library/src/components/forms/FormError/FormError';
import { TextInput } from '@bambi/component-library/src/components/inputs/TextInput/TextInput';
import { Controller, useFormContext } from 'react-hook-form';

import type { InvoiceNestedLineItemWithId } from '../InvoiceFormContext';
import { useInvoiceFormContext } from '../InvoiceFormContext';

interface LineItemDescriptionEditCellProps {
  lineItem: InvoiceNestedLineItemWithId;
}
export function LineItemDescriptionEditCell({
  lineItem,
}: LineItemDescriptionEditCellProps) {
  const { control, clearErrors } = useFormContext<Invoice>();

  const { findLineItemIndex } = useInvoiceFormContext();
  const actualIndex = findLineItemIndex(lineItem);

  return (
    <Controller
      control={control}
      name={`line_items.${actualIndex}.description`}
      render={({ field, fieldState }) => {
        return (
          <div>
            <TextInput
              type="text"
              value={field.value}
              placeholder="Enter item description"
              onChange={(e) => {
                const value = e.target.value;
                field.onChange(value);
                // The error is set manually on submit (handleSubmit's
                // revalidation never runs on the aborted path), so clear it
                // ourselves once the field has a non-blank value.
                if (fieldState.error && value.trim()) {
                  clearErrors(`line_items.${actualIndex}.description`);
                }
              }}
              error={fieldState.error?.message}
            />
            {fieldState.error?.message && (
              <FormError error={fieldState.error.message} />
            )}
          </div>
        );
      }}
    />
  );
}
